import { Typography, Box, CircularProgress, Grid } from "@mui/material";
import { useState, useEffect } from "react";

const CustomLoader = () => {
    // Array of messages to display
    const messages = [
        "Saving...",
        "Be patient, we're processing your request.",
        "Hang tight, almost done!",
        "Just a moment, completing your operation.",
        "Almost there, thank you for waiting!",
        "Your data is being saved, please hold on.",
        "We appreciate your patience, finalizing..."
    ];

    // State to manage the current message index
    const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

    // Effect to change the message every 2 seconds
    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentMessageIndex((prevIndex) => (prevIndex + 1) % messages.length);
        }, 2000); // Change message every 2 seconds

        // Cleanup interval on component unmount
        return () => clearInterval(intervalId);
    }, []);

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
            <Grid container direction="column" alignItems="center">
                <Grid item>
                    <CircularProgress />
                </Grid>
                <Grid item>
                    <Typography>{messages[currentMessageIndex]}</Typography>
                </Grid>
            </Grid>
        </Box>
    );
}

export default CustomLoader;
